import Text from './text';
import Link from './link';

Text.Link = Link;

export default Text;
